import { Dialogue, type DialogueProps } from './Dialogue.js';

export type ModalProps = Omit<DialogueProps, 'forme' | 'nu'>;

/** Un dialogue centré (`.dialogue` du kit). */
export function Modal(props: ModalProps): React.ReactElement | null {
  return <Dialogue {...props} />;
}
